import { Injectable } from '@angular/core';

import { pluck } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { GdprSaveBody } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class GdprConfigurationHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch() {
    return this.httpApi.get('gdpr/configuration').pipe(pluck('configuration'));
  }

  public save(body: GdprSaveBody) {
    return this.httpApi.patch('gdpr/configuration', null, body).pipe(pluck('configuration'));
  }
}
